export default {
	acronym: "Acronym",
	acronymHint: "2-10 uppercase characters, will be used in the temple URL",
	brandingDesc: "Complete system for Umbanda temple management",
	brandingTitle: "Manage your Temple",
	confirmPassword: "Confirm password",
	error: "Error registering. Please try again.",
	submit: "Register Temple",
	subscribingNotice: "You're starting a plan subscription. After creating your account and confirming your email, you'll review the plan and complete the payment.",
	subtitle: "Create your account and register your temple",
	success: "Registration completed! Check your email to activate your account.",
	templeName: "Temple Name",
	templeNameHint: "Capitalize each word (or type it all in uppercase)",
	title: "Register Temple",
};
